import { Routes } from '@angular/router';
import { Brand } from './brand/brand';
import { HourTypeGroup } from './hour-type-group/hour-type-group';
import { EquationVariableGroup } from './equation-variable-group/equation-variable-group';
import { GeneticMaterialCrossingType } from './genetic-material-crossing-type/genetic-material-crossing-type';
import { Distance } from './distance/distance';
import { GeneticMaterialOrigin } from './genetic-material-origin/genetic-material-origin';
import { Holiday } from './holiday/holiday';
import { DestinationIncoTerm } from './destination-inco-term/destination-inco-term';
import { GeneticMaterialType } from './genetic-material-type/genetic-material-type';
import { DistanceRange } from './distance-range/distance-range';
import { GeneticMaterialCrossing } from './genetic-material-crossing/genetic-material-crossing';
import { HourType } from './hour-type/hour-type';
import { EquationVariable } from './equation-variable/equation-variable';
import { Reason } from './reason/reason';
import { ReasonGroup } from './reason-group/reason-group';
import { RestDay } from './rest-day/rest-day';
import { UnitOfMeasure } from './unit-of-measure/unit-of-measure';
import { TimeSlot } from './time-slot/time-slot';
import { RoadPropertyType } from './road-property-type/road-property-type';
import { WorkType } from './work-type/work-type';
import { ConsumableResource } from './consumable-resource/consumable-resource';
import { RecommendedQuantityPerResource } from './recommended-quantity-per-resource/recommended-quantity-per-resource';
import { Nozzle } from './nozzle/nozzle';
import { Day } from './day/day';
import { Month } from './month/month';
import { authGuard, permissionGuard } from '@abp/ng.core';
import { BRAND_CONFIG } from './brand/brand.config';
import { HOURTYPEGROUP_CONFIG } from './hour-type-group/hour-type-group.config';
import { EQUATIONVARIABLEGROUP_CONFIG } from './equation-variable-group/equation-variable-group.config';
import { GENETICMATERIALCROSSINGTYPE_CONFIG } from './genetic-material-crossing-type/genetic-material-crossing-type.config';
import { DISTANCE_CONFIG } from './distance/distance.config';
import { GENETICMATERIALORIGIN_CONFIG } from './genetic-material-origin/genetic-material-origin.config';
import { HOLIDAY_CONFIG } from './holiday/holiday.config';
import { DESTINATIONINCOTERM_CONFIG } from './destination-inco-term/destination-inco-term.config';
import { GENETICMATERIALTYPE_CONFIG } from './genetic-material-type/genetic-material-type.config';
import { DISTANCERANGE_CONFIG } from './distance-range/distance-range.config';
import { GENETICMATERIALCROSSING_CONFIG } from './genetic-material-crossing/genetic-material-crossing.config';
import { HOURTYPE_CONFIG } from './hour-type/hour-type.config';
import { EQUATIONVARIABLE_CONFIG } from './equation-variable/equation-variable.config';
import { REASON_CONFIG } from './reason/reason.config';
import { RESTDAY_CONFIG } from './rest-day/rest-day.config';
import { UNITOFMEASURE_CONFIG } from './unit-of-measure/unit-of-measure.config';
import { TIMESLOT_CONFIG } from './time-slot/time-slot.config';
import { ROADPROPERTYTYPE_CONFIG } from './road-property-type/road-property-type.config';
import { WORKTYPE_CONFIG } from './work-type/work-type.config';
import { CONSUMABLERESOURCE_CONFIG } from './consumable-resource/consumable-resource.config';
import { RECOMMENDEDQUANTITYPERRESOURCE_CONFIG } from './recommended-quantity-per-resource/recommended-quantity-per-resource.config';
import { NOZZLE_CONFIG } from './nozzle/nozzle.config';
import { DAY_CONFIG } from './day/day.config';
import { MONTH_CONFIG } from './month/month.config';
import { REASONGROUP_CONFIG } from './reason-group/reason-group.config';
import { VendorPerPerson } from './vendor-per-person/vendor-per-person';
import { VENDORPERPERSON_CONFIG } from './vendor-per-person/vendor-per-person.config';
import { Person } from './person/person';
import { PERSON_CONFIG } from './person/person.config';
import { PLANT_CONFIG } from './plant/plant.config';
import { GASOILANDLUBRICANT_CONFIG } from './gas-oil-and-lubricant/gas-oil-and-lubricant.config';
import { MATERIAL_CONFIG } from './material/material.config';
import { PRODUCTCATEGORY_CONFIG } from './product-category/product-category.config';
import { MOVILIZATIONTYPE_CONFIG } from './movilization-type/movilization-type.config';
import { GASOILPROVIDER_CONFIG } from './gas-oil-provider/gas-oil-provider.config';
import { MATERIALTYPE_CONFIG } from './material-type/material-type.config';
import { PERSONCATEGORY_CONFIG } from './person-category/person-category.config';
import { TRACTORATTACHMENTTYPE_CONFIG } from './tractor-attachment-type/tractor-attachment-type.config';
import { VEHICLETECHNOLOGY_CONFIG } from './vehicle-technology/vehicle-technology.config';
import { MODEL_CONFIG } from './model/model.config';
import { ENERGYSOURCE_CONFIG } from './energy-source/energy-source.config';
import { TRACTORTYPE_CONFIG } from './tractor-type/tractor-type.config';
import { TRACTORCATEGORY_CONFIG } from './tractor-category/tractor-category.config';
import { MACHINETYPE_CONFIG } from './machine-type/machine-type.config';
import { MACHINE_CONFIG } from './machine/machine.config';
import { VEHICLECATEGORY_CONFIG } from './vehicle-category/vehicle-category.config';
import { HARVESTER_CONFIG } from './harvester/harvester.config';
import { FELLER_CONFIG } from './feller/feller.config';
import { CLAW_CONFIG } from './claw/claw.config';
import { TRACTOR_CONFIG } from './tractor/tractor.config';
import { TRACTORATTACHMENT_CONFIG } from './tractor-attachment/tractor-attachment.config';
import { FORWARDER_CONFIG } from './forwarder/forwarder.config';
import { MACHINEHEADERCHANGEHISTORIC_CONFIG } from './machine-header-change-historic/machine-header-change-historic.config';
import { MACHINECLAWCHANGEHISTORIC_CONFIG } from './machine-claw-change-historic/machine-claw-change-historic.config';
import { TRACTORATTACHMENTPERTRACTOR_CONFIG } from './tractor-attachment-per-tractor/tractor-attachment-per-tractor.config';
import { SPECIESGROUP_CONFIG } from './species-group/species-group.config';
import { FORWARDERCAPACITY_CONFIG } from './forwarder-capacity/forwarder-capacity.config';
import { TRUCKCATEGORY_CONFIG } from './truck-category/truck-category.config';
import { PERSONCATEGORYMAPPINGBIOFOREST_CONFIG } from './person-category-mapping-bio-forest/person-category-mapping-bio-forest.config';
import { CONSUMABLETYPE_CONFIG } from './consumable-type/consumable-type.config';
import { QUICKRESPONSECODE_CONFIG } from './quick-response-code/quick-response-code.config';
import { CHEMICALTYPE_CONFIG } from './chemical-type/chemical-type.config';
import { GASOILANDLUBRICANTTYPE_CONFIG } from './gas-oil-and-lubricant-type/gas-oil-and-lubricant-type.config';
import { GENETICMATERIALGROUP_CONFIG } from './genetic-material-group/genetic-material-group.config';
import { TRACTIONTYPE_CONFIG } from './traction-type/traction-type.config';
import { SPECIES_CONFIG } from './species/species.config';
import { GENETICMATERIAL_CONFIG } from './genetic-material/genetic-material.config';
import { CONSUMABLE_CONFIG } from './consumable/consumable.config';
import { TRUCKLOGIC_CONFIG } from './truck-logic/truck-logic.config';
import { VEHICLE_CONFIG } from './vehicle/vehicle.config';
import { LIGHTVEHICLE_CONFIG } from './light-vehicle/light-vehicle.config';
import { FINALPRODUCT_CONFIG } from './final-product/final-product.config';
import { CHEMICAL_CONFIG } from './chemical/chemical.config';
import { WOODPRODUCTDETAIL_CONFIG } from './wood-product-detail/wood-product-detail.config';
import { TRUCK_CONFIG } from './truck/truck.config';
import { NURSERYTRUCKPARAMETER_CONFIG } from './nursery-truck-parameter/nursery-truck-parameter.config';
import { VEHICLETYPE_CONFIG } from './vehicle-type/vehicle-type.config';
import { FUNDAMENTALPROCESS_CONFIG } from './fundamental-process/fundamental-process.config';
import { MAINPROCESS_CONFIG } from './main-process/main-process.config';
import { MAINTRUCKHISTORIC_CONFIG } from './main-truck-historic/main-truck-historic.config';
import { EXTERNALSERVICE_CONFIG } from './external-service/external-service.config';
import { HEADER_CONFIG } from './header/header.config';
import { HOLIDAYDATE_CONFIG } from './holiday-date/holiday-date.config';
import { REMSOFTSPECIESGROUP_CONFIG } from './remsoft-species-group/remsoft-species-group.config';
import { PLANTTYPE_CONFIG } from './plant-type/plant-type.config';
import { SPECIESGROUPPLANTTYPE_CONFIG } from './species-group-plant-type/species-group-plant-type.config';
import { SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG } from './species-group-chip-cubic-meter-coefficient/species-group-chip-cubic-meter-coefficient.config';
import { SPECIESPERVEHICLECATEGORY_CONFIG } from './species-per-vehicle-category/species-per-vehicle-category.config';
import { Plant } from './plant/plant';
import { GasOilAndLubricant } from './gas-oil-and-lubricant/gas-oil-and-lubricant';
import { Material } from './material/material';
import { ProductCategory } from './product-category/product-category';
import { MovilizationType } from './movilization-type/movilization-type';
import { GasOilProvider } from './gas-oil-provider/gas-oil-provider';
import { MaterialType } from './material-type/material-type';
import { PersonCategory } from './person-category/person-category';
import { TractorAttachmentType } from './tractor-attachment-type/tractor-attachment-type';
import { VehicleTechnology } from './vehicle-technology/vehicle-technology';
import { Model } from './model/model';
import { EnergySource } from './energy-source/energy-source';
import { TractorType } from './tractor-type/tractor-type';
import { TractorCategory } from './tractor-category/tractor-category';
import { MachineType } from './machine-type/machine-type';
import { Machine } from './machine/machine';
import { VehicleCategory } from './vehicle-category/vehicle-category';
import { Harvester } from './harvester/harvester';
import { Feller } from './feller/feller';
import { Claw } from './claw/claw';
import { Tractor } from './tractor/tractor';
import { TractorAttachment } from './tractor-attachment/tractor-attachment';
import { Forwarder } from './forwarder/forwarder';
import { MachineHeaderChangeHistoric } from './machine-header-change-historic/machine-header-change-historic';
import { MachineClawChangeHistoric } from './machine-claw-change-historic/machine-claw-change-historic';
import { TractorAttachmentPerTractor } from './tractor-attachment-per-tractor/tractor-attachment-per-tractor';
import { SpeciesGroup } from './species-group/species-group';
import { ForwarderCapacity } from './forwarder-capacity/forwarder-capacity';
import { TruckCategory } from './truck-category/truck-category';
import { PersonCategoryMappingBioForest } from './person-category-mapping-bio-forest/person-category-mapping-bio-forest';
import { ConsumableType } from './consumable-type/consumable-type';
import { QuickResponseCode } from './quick-response-code/quick-response-code';
import { ChemicalType } from './chemical-type/chemical-type';
import { GasOilAndLubricantType } from './gas-oil-and-lubricant-type/gas-oil-and-lubricant-type';
import { GeneticMaterialGroup } from './genetic-material-group/genetic-material-group';
import { TractionType } from './traction-type/traction-type';
import { Species } from './species/species';
import { GeneticMaterial } from './genetic-material/genetic-material';
import { Consumable } from './consumable/consumable';
import { TruckLogic } from './truck-logic/truck-logic';
import { Vehicle } from './vehicle/vehicle';
import { LightVehicle } from './light-vehicle/light-vehicle';
import { FinalProduct } from './final-product/final-product';
import { Chemical } from './chemical/chemical';
import { WoodProductDetail } from './wood-product-detail/wood-product-detail';
import { Truck } from './truck/truck';
import { NurseryTruckParameter } from './nursery-truck-parameter/nursery-truck-parameter';
import { VehicleType } from './vehicle-type/vehicle-type';
import { FundamentalProcess } from './fundamental-process/fundamental-process';
import { MainProcess } from './main-process/main-process';
import { MainTruckHistoric } from './main-truck-historic/main-truck-historic';
import { ExternalService } from './external-service/external-service';
import { Header } from './header/header';
import { HolidayDate } from './holiday-date/holiday-date';
import { RemsoftSpeciesGroup } from './remsoft-species-group/remsoft-species-group';
import { PlantType } from './plant-type/plant-type';
import { SpeciesGroupPlantType } from './species-group-plant-type/species-group-plant-type';
import { SpeciesGroupChipCubicMeterCoefficient } from './species-group-chip-cubic-meter-coefficient/species-group-chip-cubic-meter-coefficient';
import { SpeciesPerVehicleCategory } from './species-per-vehicle-category/species-per-vehicle-category';

export const GENERAL_ROUTES: Routes = [
  {
    path: 'brand',
    pathMatch: 'full',
    component: Brand,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: BRAND_CONFIG.permission,
      showInMenu: BRAND_CONFIG.showInMenu,
      menuCategory: BRAND_CONFIG.menuCategory,
      menuSubcategory: BRAND_CONFIG.menuSubcategory,
      menuTitle: BRAND_CONFIG.localizationKey,
    },
  },
  {
    path: 'hour-type-group',
    pathMatch: 'full',
    component: HourTypeGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HOURTYPEGROUP_CONFIG.permission,
      showInMenu: HOURTYPEGROUP_CONFIG.showInMenu,
      menuCategory: HOURTYPEGROUP_CONFIG.menuCategory,
      menuSubcategory: HOURTYPEGROUP_CONFIG.menuSubcategory,
      menuTitle: HOURTYPEGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'equation-variable-group',
    pathMatch: 'full',
    component: EquationVariableGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EQUATIONVARIABLEGROUP_CONFIG.permission,
      showInMenu: EQUATIONVARIABLEGROUP_CONFIG.showInMenu,
      menuCategory: EQUATIONVARIABLEGROUP_CONFIG.menuCategory,
      menuSubcategory: EQUATIONVARIABLEGROUP_CONFIG.menuSubcategory,
      menuTitle: EQUATIONVARIABLEGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'genetic-material-crossing-type',
    pathMatch: 'full',
    component: GeneticMaterialCrossingType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENETICMATERIALCROSSINGTYPE_CONFIG.permission,
      showInMenu: GENETICMATERIALCROSSINGTYPE_CONFIG.showInMenu,
      menuCategory: GENETICMATERIALCROSSINGTYPE_CONFIG.menuCategory,
      menuSubcategory: GENETICMATERIALCROSSINGTYPE_CONFIG.menuSubcategory,
      menuTitle: GENETICMATERIALCROSSINGTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'distance',
    pathMatch: 'full',
    component: Distance,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DISTANCE_CONFIG.permission,
      showInMenu: DISTANCE_CONFIG.showInMenu,
      menuCategory: DISTANCE_CONFIG.menuCategory,
      menuSubcategory: DISTANCE_CONFIG.menuSubcategory,
      menuTitle: DISTANCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'genetic-material-origin',
    pathMatch: 'full',
    component: GeneticMaterialOrigin,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENETICMATERIALORIGIN_CONFIG.permission,
      showInMenu: GENETICMATERIALORIGIN_CONFIG.showInMenu,
      menuCategory: GENETICMATERIALORIGIN_CONFIG.menuCategory,
      menuSubcategory: GENETICMATERIALORIGIN_CONFIG.menuSubcategory,
      menuTitle: GENETICMATERIALORIGIN_CONFIG.localizationKey,
    },
  },
  {
    path: 'holiday',
    pathMatch: 'full',
    component: Holiday,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HOLIDAY_CONFIG.permission,
      showInMenu: HOLIDAY_CONFIG.showInMenu,
      menuCategory: HOLIDAY_CONFIG.menuCategory,
      menuSubcategory: HOLIDAY_CONFIG.menuSubcategory,
      menuTitle: HOLIDAY_CONFIG.localizationKey,
    },
  },
  {
    path: 'destination-inco-term',
    pathMatch: 'full',
    component: DestinationIncoTerm,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DESTINATIONINCOTERM_CONFIG.permission,
      showInMenu: DESTINATIONINCOTERM_CONFIG.showInMenu,
      menuCategory: DESTINATIONINCOTERM_CONFIG.menuCategory,
      menuSubcategory: DESTINATIONINCOTERM_CONFIG.menuSubcategory,
      menuTitle: DESTINATIONINCOTERM_CONFIG.localizationKey,
    },
  },
  {
    path: 'genetic-material-type',
    pathMatch: 'full',
    component: GeneticMaterialType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENETICMATERIALTYPE_CONFIG.permission,
      showInMenu: GENETICMATERIALTYPE_CONFIG.showInMenu,
      menuCategory: GENETICMATERIALTYPE_CONFIG.menuCategory,
      menuSubcategory: GENETICMATERIALTYPE_CONFIG.menuSubcategory,
      menuTitle: GENETICMATERIALTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'distance-range',
    pathMatch: 'full',
    component: DistanceRange,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DISTANCERANGE_CONFIG.permission,
      showInMenu: DISTANCERANGE_CONFIG.showInMenu,
      menuCategory: DISTANCERANGE_CONFIG.menuCategory,
      menuSubcategory: DISTANCERANGE_CONFIG.menuSubcategory,
      menuTitle: DISTANCERANGE_CONFIG.localizationKey,
    },
  },
  {
    path: 'genetic-material-crossing',
    pathMatch: 'full',
    component: GeneticMaterialCrossing,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENETICMATERIALCROSSING_CONFIG.permission,
      showInMenu: GENETICMATERIALCROSSING_CONFIG.showInMenu,
      menuCategory: GENETICMATERIALCROSSING_CONFIG.menuCategory,
      menuSubcategory: GENETICMATERIALCROSSING_CONFIG.menuSubcategory,
      menuTitle: GENETICMATERIALCROSSING_CONFIG.localizationKey,
    },
  },
  {
    path: 'hour-type',
    pathMatch: 'full',
    component: HourType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HOURTYPE_CONFIG.permission,
      showInMenu: HOURTYPE_CONFIG.showInMenu,
      menuCategory: HOURTYPE_CONFIG.menuCategory,
      menuSubcategory: HOURTYPE_CONFIG.menuSubcategory,
      menuTitle: HOURTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'equation-variable',
    pathMatch: 'full',
    component: EquationVariable,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EQUATIONVARIABLE_CONFIG.permission,
      showInMenu: EQUATIONVARIABLE_CONFIG.showInMenu,
      menuCategory: EQUATIONVARIABLE_CONFIG.menuCategory,
      menuSubcategory: EQUATIONVARIABLE_CONFIG.menuSubcategory,
      menuTitle: EQUATIONVARIABLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'reason',
    pathMatch: 'full',
    component: Reason,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REASON_CONFIG.permission,
      showInMenu: REASON_CONFIG.showInMenu,
      menuCategory: REASON_CONFIG.menuCategory,
      menuSubcategory: REASON_CONFIG.menuSubcategory,
      menuTitle: REASON_CONFIG.localizationKey,
    },
  },
  {
    path: 'rest-day',
    pathMatch: 'full',
    component: RestDay,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: RESTDAY_CONFIG.permission,
      showInMenu: RESTDAY_CONFIG.showInMenu,
      menuCategory: RESTDAY_CONFIG.menuCategory,
      menuSubcategory: RESTDAY_CONFIG.menuSubcategory,
      menuTitle: RESTDAY_CONFIG.localizationKey,
    },
  },
  {
    path: 'unit-of-measure',
    pathMatch: 'full',
    component: UnitOfMeasure,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: UNITOFMEASURE_CONFIG.permission,
      showInMenu: UNITOFMEASURE_CONFIG.showInMenu,
      menuCategory: UNITOFMEASURE_CONFIG.menuCategory,
      menuSubcategory: UNITOFMEASURE_CONFIG.menuSubcategory,
      menuTitle: UNITOFMEASURE_CONFIG.localizationKey,
    },
  },
  {
    path: 'time-slot',
    pathMatch: 'full',
    component: TimeSlot,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TIMESLOT_CONFIG.permission,
      showInMenu: TIMESLOT_CONFIG.showInMenu,
      menuCategory: TIMESLOT_CONFIG.menuCategory,
      menuSubcategory: TIMESLOT_CONFIG.menuSubcategory,
      menuTitle: TIMESLOT_CONFIG.localizationKey,
    },
  },
  {
    path: 'road-property-type',
    pathMatch: 'full',
    component: RoadPropertyType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROADPROPERTYTYPE_CONFIG.permission,
      showInMenu: ROADPROPERTYTYPE_CONFIG.showInMenu,
      menuCategory: ROADPROPERTYTYPE_CONFIG.menuCategory,
      menuSubcategory: ROADPROPERTYTYPE_CONFIG.menuSubcategory,
      menuTitle: ROADPROPERTYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'work-type',
    pathMatch: 'full',
    component: WorkType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WORKTYPE_CONFIG.permission,
      showInMenu: WORKTYPE_CONFIG.showInMenu,
      menuCategory: WORKTYPE_CONFIG.menuCategory,
      menuSubcategory: WORKTYPE_CONFIG.menuSubcategory,
      menuTitle: WORKTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'consumable-resource',
    pathMatch: 'full',
    component: ConsumableResource,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONSUMABLERESOURCE_CONFIG.permission,
      showInMenu: CONSUMABLERESOURCE_CONFIG.showInMenu,
      menuCategory: CONSUMABLERESOURCE_CONFIG.menuCategory,
      menuSubcategory: CONSUMABLERESOURCE_CONFIG.menuSubcategory,
      menuTitle: CONSUMABLERESOURCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'recommended-quantity-per-resource',
    pathMatch: 'full',
    component: RecommendedQuantityPerResource,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: RECOMMENDEDQUANTITYPERRESOURCE_CONFIG.permission,
      showInMenu: RECOMMENDEDQUANTITYPERRESOURCE_CONFIG.showInMenu,
      menuCategory: RECOMMENDEDQUANTITYPERRESOURCE_CONFIG.menuCategory,
      menuSubcategory: RECOMMENDEDQUANTITYPERRESOURCE_CONFIG.menuSubcategory,
      menuTitle: RECOMMENDEDQUANTITYPERRESOURCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'nozzle',
    pathMatch: 'full',
    component: Nozzle,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: NOZZLE_CONFIG.permission,
      showInMenu: NOZZLE_CONFIG.showInMenu,
      menuCategory: NOZZLE_CONFIG.menuCategory,
      menuSubcategory: NOZZLE_CONFIG.menuSubcategory,
      menuTitle: NOZZLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'day',
    pathMatch: 'full',
    component: Day,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DAY_CONFIG.permission,
      showInMenu: DAY_CONFIG.showInMenu,
      menuCategory: DAY_CONFIG.menuCategory,
      menuSubcategory: DAY_CONFIG.menuSubcategory,
      menuTitle: DAY_CONFIG.localizationKey,
    },
  },
  {
    path: 'month',
    pathMatch: 'full',
    component: Month,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MONTH_CONFIG.permission,
      showInMenu: MONTH_CONFIG.showInMenu,
      menuCategory: MONTH_CONFIG.menuCategory,
      menuSubcategory: MONTH_CONFIG.menuSubcategory,
      menuTitle: MONTH_CONFIG.localizationKey,
    },
  },
  {
    path: 'reason-group',
    pathMatch: 'full',
    component: ReasonGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REASONGROUP_CONFIG.permission,
      showInMenu: REASONGROUP_CONFIG.showInMenu,
      menuCategory: REASONGROUP_CONFIG.menuCategory,
      menuSubcategory: REASONGROUP_CONFIG.menuSubcategory,
      menuTitle: REASONGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-per-person',
    pathMatch: 'full',
    component: VendorPerPerson,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORPERPERSON_CONFIG.permission,
      showInMenu: VENDORPERPERSON_CONFIG.showInMenu,
      menuCategory: VENDORPERPERSON_CONFIG.menuCategory,
      menuSubcategory: VENDORPERPERSON_CONFIG.menuSubcategory,
      menuTitle: VENDORPERPERSON_CONFIG.localizationKey,
    },
  },
  {
    path: 'person',
    pathMatch: 'full',
    component: Person,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PERSON_CONFIG.permission,
      showInMenu: PERSON_CONFIG.showInMenu,
      menuCategory: PERSON_CONFIG.menuCategory,
      menuSubcategory: PERSON_CONFIG.menuSubcategory,
      menuTitle: PERSON_CONFIG.localizationKey,
    },
  },
  {
    path: 'plant',
    pathMatch: 'full',
    component: Plant,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANT_CONFIG.permission,
      showInMenu: PLANT_CONFIG.showInMenu,
      menuCategory: PLANT_CONFIG.menuCategory,
      menuSubcategory: PLANT_CONFIG.menuSubcategory,
      menuTitle: PLANT_CONFIG.localizationKey,
    },
  },
  {
    path: 'gas-oil-and-lubricant',
    pathMatch: 'full',
    component: GasOilAndLubricant,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GASOILANDLUBRICANT_CONFIG.permission,
      showInMenu: GASOILANDLUBRICANT_CONFIG.showInMenu,
      menuCategory: GASOILANDLUBRICANT_CONFIG.menuCategory,
      menuSubcategory: GASOILANDLUBRICANT_CONFIG.menuSubcategory,
      menuTitle: GASOILANDLUBRICANT_CONFIG.localizationKey,
    },
  },
  {
    path: 'material',
    pathMatch: 'full',
    component: Material,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MATERIAL_CONFIG.permission,
      showInMenu: MATERIAL_CONFIG.showInMenu,
      menuCategory: MATERIAL_CONFIG.menuCategory,
      menuSubcategory: MATERIAL_CONFIG.menuSubcategory,
      menuTitle: MATERIAL_CONFIG.localizationKey,
    },
  },
  {
    path: 'product-category',
    pathMatch: 'full',
    component: ProductCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PRODUCTCATEGORY_CONFIG.permission,
      showInMenu: PRODUCTCATEGORY_CONFIG.showInMenu,
      menuCategory: PRODUCTCATEGORY_CONFIG.menuCategory,
      menuSubcategory: PRODUCTCATEGORY_CONFIG.menuSubcategory,
      menuTitle: PRODUCTCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'movilization-type',
    pathMatch: 'full',
    component: MovilizationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MOVILIZATIONTYPE_CONFIG.permission,
      showInMenu: MOVILIZATIONTYPE_CONFIG.showInMenu,
      menuCategory: MOVILIZATIONTYPE_CONFIG.menuCategory,
      menuSubcategory: MOVILIZATIONTYPE_CONFIG.menuSubcategory,
      menuTitle: MOVILIZATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'gas-oil-provider',
    pathMatch: 'full',
    component: GasOilProvider,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GASOILPROVIDER_CONFIG.permission,
      showInMenu: GASOILPROVIDER_CONFIG.showInMenu,
      menuCategory: GASOILPROVIDER_CONFIG.menuCategory,
      menuSubcategory: GASOILPROVIDER_CONFIG.menuSubcategory,
      menuTitle: GASOILPROVIDER_CONFIG.localizationKey,
    },
  },
  {
    path: 'material-type',
    pathMatch: 'full',
    component: MaterialType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MATERIALTYPE_CONFIG.permission,
      showInMenu: MATERIALTYPE_CONFIG.showInMenu,
      menuCategory: MATERIALTYPE_CONFIG.menuCategory,
      menuSubcategory: MATERIALTYPE_CONFIG.menuSubcategory,
      menuTitle: MATERIALTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'person-category',
    pathMatch: 'full',
    component: PersonCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PERSONCATEGORY_CONFIG.permission,
      showInMenu: PERSONCATEGORY_CONFIG.showInMenu,
      menuCategory: PERSONCATEGORY_CONFIG.menuCategory,
      menuSubcategory: PERSONCATEGORY_CONFIG.menuSubcategory,
      menuTitle: PERSONCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'tractor-attachment-type',
    pathMatch: 'full',
    component: TractorAttachmentType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTORATTACHMENTTYPE_CONFIG.permission,
      showInMenu: TRACTORATTACHMENTTYPE_CONFIG.showInMenu,
      menuCategory: TRACTORATTACHMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: TRACTORATTACHMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: TRACTORATTACHMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'vehicle-technology',
    pathMatch: 'full',
    component: VehicleTechnology,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VEHICLETECHNOLOGY_CONFIG.permission,
      showInMenu: VEHICLETECHNOLOGY_CONFIG.showInMenu,
      menuCategory: VEHICLETECHNOLOGY_CONFIG.menuCategory,
      menuSubcategory: VEHICLETECHNOLOGY_CONFIG.menuSubcategory,
      menuTitle: VEHICLETECHNOLOGY_CONFIG.localizationKey,
    },
  },
  {
    path: 'model',
    pathMatch: 'full',
    component: Model,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MODEL_CONFIG.permission,
      showInMenu: MODEL_CONFIG.showInMenu,
      menuCategory: MODEL_CONFIG.menuCategory,
      menuSubcategory: MODEL_CONFIG.menuSubcategory,
      menuTitle: MODEL_CONFIG.localizationKey,
    },
  },
  {
    path: 'energy-source',
    pathMatch: 'full',
    component: EnergySource,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ENERGYSOURCE_CONFIG.permission,
      showInMenu: ENERGYSOURCE_CONFIG.showInMenu,
      menuCategory: ENERGYSOURCE_CONFIG.menuCategory,
      menuSubcategory: ENERGYSOURCE_CONFIG.menuSubcategory,
      menuTitle: ENERGYSOURCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'tractor-type',
    pathMatch: 'full',
    component: TractorType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTORTYPE_CONFIG.permission,
      showInMenu: TRACTORTYPE_CONFIG.showInMenu,
      menuCategory: TRACTORTYPE_CONFIG.menuCategory,
      menuSubcategory: TRACTORTYPE_CONFIG.menuSubcategory,
      menuTitle: TRACTORTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'tractor-category',
    pathMatch: 'full',
    component: TractorCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTORCATEGORY_CONFIG.permission,
      showInMenu: TRACTORCATEGORY_CONFIG.showInMenu,
      menuCategory: TRACTORCATEGORY_CONFIG.menuCategory,
      menuSubcategory: TRACTORCATEGORY_CONFIG.menuSubcategory,
      menuTitle: TRACTORCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'machine-type',
    pathMatch: 'full',
    component: MachineType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MACHINETYPE_CONFIG.permission,
      showInMenu: MACHINETYPE_CONFIG.showInMenu,
      menuCategory: MACHINETYPE_CONFIG.menuCategory,
      menuSubcategory: MACHINETYPE_CONFIG.menuSubcategory,
      menuTitle: MACHINETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'machine',
    pathMatch: 'full',
    component: Machine,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MACHINE_CONFIG.permission,
      showInMenu: MACHINE_CONFIG.showInMenu,
      menuCategory: MACHINE_CONFIG.menuCategory,
      menuSubcategory: MACHINE_CONFIG.menuSubcategory,
      menuTitle: MACHINE_CONFIG.localizationKey,
    },
  },
  {
    path: 'vehicle-category',
    pathMatch: 'full',
    component: VehicleCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VEHICLECATEGORY_CONFIG.permission,
      showInMenu: VEHICLECATEGORY_CONFIG.showInMenu,
      menuCategory: VEHICLECATEGORY_CONFIG.menuCategory,
      menuSubcategory: VEHICLECATEGORY_CONFIG.menuSubcategory,
      menuTitle: VEHICLECATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'harvester',
    pathMatch: 'full',
    component: Harvester,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HARVESTER_CONFIG.permission,
      showInMenu: HARVESTER_CONFIG.showInMenu,
      menuCategory: HARVESTER_CONFIG.menuCategory,
      menuSubcategory: HARVESTER_CONFIG.menuSubcategory,
      menuTitle: HARVESTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'feller',
    pathMatch: 'full',
    component: Feller,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FELLER_CONFIG.permission,
      showInMenu: FELLER_CONFIG.showInMenu,
      menuCategory: FELLER_CONFIG.menuCategory,
      menuSubcategory: FELLER_CONFIG.menuSubcategory,
      menuTitle: FELLER_CONFIG.localizationKey,
    },
  },
  {
    path: 'claw',
    pathMatch: 'full',
    component: Claw,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CLAW_CONFIG.permission,
      showInMenu: CLAW_CONFIG.showInMenu,
      menuCategory: CLAW_CONFIG.menuCategory,
      menuSubcategory: CLAW_CONFIG.menuSubcategory,
      menuTitle: CLAW_CONFIG.localizationKey,
    },
  },
  {
    path: 'tractor',
    pathMatch: 'full',
    component: Tractor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTOR_CONFIG.permission,
      showInMenu: TRACTOR_CONFIG.showInMenu,
      menuCategory: TRACTOR_CONFIG.menuCategory,
      menuSubcategory: TRACTOR_CONFIG.menuSubcategory,
      menuTitle: TRACTOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'tractor-attachment',
    pathMatch: 'full',
    component: TractorAttachment,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTORATTACHMENT_CONFIG.permission,
      showInMenu: TRACTORATTACHMENT_CONFIG.showInMenu,
      menuCategory: TRACTORATTACHMENT_CONFIG.menuCategory,
      menuSubcategory: TRACTORATTACHMENT_CONFIG.menuSubcategory,
      menuTitle: TRACTORATTACHMENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'forwarder',
    pathMatch: 'full',
    component: Forwarder,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORWARDER_CONFIG.permission,
      showInMenu: FORWARDER_CONFIG.showInMenu,
      menuCategory: FORWARDER_CONFIG.menuCategory,
      menuSubcategory: FORWARDER_CONFIG.menuSubcategory,
      menuTitle: FORWARDER_CONFIG.localizationKey,
    },
  },
  {
    path: 'machine-header-change-historic',
    pathMatch: 'full',
    component: MachineHeaderChangeHistoric,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MACHINEHEADERCHANGEHISTORIC_CONFIG.permission,
      showInMenu: MACHINEHEADERCHANGEHISTORIC_CONFIG.showInMenu,
      menuCategory: MACHINEHEADERCHANGEHISTORIC_CONFIG.menuCategory,
      menuSubcategory: MACHINEHEADERCHANGEHISTORIC_CONFIG.menuSubcategory,
      menuTitle: MACHINEHEADERCHANGEHISTORIC_CONFIG.localizationKey,
    },
  },
  {
    path: 'machine-claw-change-historic',
    pathMatch: 'full',
    component: MachineClawChangeHistoric,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MACHINECLAWCHANGEHISTORIC_CONFIG.permission,
      showInMenu: MACHINECLAWCHANGEHISTORIC_CONFIG.showInMenu,
      menuCategory: MACHINECLAWCHANGEHISTORIC_CONFIG.menuCategory,
      menuSubcategory: MACHINECLAWCHANGEHISTORIC_CONFIG.menuSubcategory,
      menuTitle: MACHINECLAWCHANGEHISTORIC_CONFIG.localizationKey,
    },
  },
  {
    path: 'tractor-attachment-per-tractor',
    pathMatch: 'full',
    component: TractorAttachmentPerTractor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTORATTACHMENTPERTRACTOR_CONFIG.permission,
      showInMenu: TRACTORATTACHMENTPERTRACTOR_CONFIG.showInMenu,
      menuCategory: TRACTORATTACHMENTPERTRACTOR_CONFIG.menuCategory,
      menuSubcategory: TRACTORATTACHMENTPERTRACTOR_CONFIG.menuSubcategory,
      menuTitle: TRACTORATTACHMENTPERTRACTOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'species-group',
    pathMatch: 'full',
    component: SpeciesGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIESGROUP_CONFIG.permission,
      showInMenu: SPECIESGROUP_CONFIG.showInMenu,
      menuCategory: SPECIESGROUP_CONFIG.menuCategory,
      menuSubcategory: SPECIESGROUP_CONFIG.menuSubcategory,
      menuTitle: SPECIESGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'forwarder-capacity',
    pathMatch: 'full',
    component: ForwarderCapacity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORWARDERCAPACITY_CONFIG.permission,
      showInMenu: FORWARDERCAPACITY_CONFIG.showInMenu,
      menuCategory: FORWARDERCAPACITY_CONFIG.menuCategory,
      menuSubcategory: FORWARDERCAPACITY_CONFIG.menuSubcategory,
      menuTitle: FORWARDERCAPACITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'truck-category',
    pathMatch: 'full',
    component: TruckCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRUCKCATEGORY_CONFIG.permission,
      showInMenu: TRUCKCATEGORY_CONFIG.showInMenu,
      menuCategory: TRUCKCATEGORY_CONFIG.menuCategory,
      menuSubcategory: TRUCKCATEGORY_CONFIG.menuSubcategory,
      menuTitle: TRUCKCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'person-category-mapping-bio-forest',
    pathMatch: 'full',
    component: PersonCategoryMappingBioForest,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PERSONCATEGORYMAPPINGBIOFOREST_CONFIG.permission,
      showInMenu: PERSONCATEGORYMAPPINGBIOFOREST_CONFIG.showInMenu,
      menuCategory: PERSONCATEGORYMAPPINGBIOFOREST_CONFIG.menuCategory,
      menuSubcategory: PERSONCATEGORYMAPPINGBIOFOREST_CONFIG.menuSubcategory,
      menuTitle: PERSONCATEGORYMAPPINGBIOFOREST_CONFIG.localizationKey,
    },
  },
  {
    path: 'consumable-type',
    pathMatch: 'full',
    component: ConsumableType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONSUMABLETYPE_CONFIG.permission,
      showInMenu: CONSUMABLETYPE_CONFIG.showInMenu,
      menuCategory: CONSUMABLETYPE_CONFIG.menuCategory,
      menuSubcategory: CONSUMABLETYPE_CONFIG.menuSubcategory,
      menuTitle: CONSUMABLETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'quick-response-code',
    pathMatch: 'full',
    component: QuickResponseCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: QUICKRESPONSECODE_CONFIG.permission,
      showInMenu: QUICKRESPONSECODE_CONFIG.showInMenu,
      menuCategory: QUICKRESPONSECODE_CONFIG.menuCategory,
      menuSubcategory: QUICKRESPONSECODE_CONFIG.menuSubcategory,
      menuTitle: QUICKRESPONSECODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'chemical-type',
    pathMatch: 'full',
    component: ChemicalType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CHEMICALTYPE_CONFIG.permission,
      showInMenu: CHEMICALTYPE_CONFIG.showInMenu,
      menuCategory: CHEMICALTYPE_CONFIG.menuCategory,
      menuSubcategory: CHEMICALTYPE_CONFIG.menuSubcategory,
      menuTitle: CHEMICALTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'gas-oil-and-lubricant-type',
    pathMatch: 'full',
    component: GasOilAndLubricantType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GASOILANDLUBRICANTTYPE_CONFIG.permission,
      showInMenu: GASOILANDLUBRICANTTYPE_CONFIG.showInMenu,
      menuCategory: GASOILANDLUBRICANTTYPE_CONFIG.menuCategory,
      menuSubcategory: GASOILANDLUBRICANTTYPE_CONFIG.menuSubcategory,
      menuTitle: GASOILANDLUBRICANTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'genetic-material-group',
    pathMatch: 'full',
    component: GeneticMaterialGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENETICMATERIALGROUP_CONFIG.permission,
      showInMenu: GENETICMATERIALGROUP_CONFIG.showInMenu,
      menuCategory: GENETICMATERIALGROUP_CONFIG.menuCategory,
      menuSubcategory: GENETICMATERIALGROUP_CONFIG.menuSubcategory,
      menuTitle: GENETICMATERIALGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'traction-type',
    pathMatch: 'full',
    component: TractionType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRACTIONTYPE_CONFIG.permission,
      showInMenu: TRACTIONTYPE_CONFIG.showInMenu,
      menuCategory: TRACTIONTYPE_CONFIG.menuCategory,
      menuSubcategory: TRACTIONTYPE_CONFIG.menuSubcategory,
      menuTitle: TRACTIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'species',
    pathMatch: 'full',
    component: Species,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIES_CONFIG.permission,
      showInMenu: SPECIES_CONFIG.showInMenu,
      menuCategory: SPECIES_CONFIG.menuCategory,
      menuSubcategory: SPECIES_CONFIG.menuSubcategory,
      menuTitle: SPECIES_CONFIG.localizationKey,
    },
  },
  {
    path: 'genetic-material',
    pathMatch: 'full',
    component: GeneticMaterial,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENETICMATERIAL_CONFIG.permission,
      showInMenu: GENETICMATERIAL_CONFIG.showInMenu,
      menuCategory: GENETICMATERIAL_CONFIG.menuCategory,
      menuSubcategory: GENETICMATERIAL_CONFIG.menuSubcategory,
      menuTitle: GENETICMATERIAL_CONFIG.localizationKey,
    },
  },
  {
    path: 'consumable',
    pathMatch: 'full',
    component: Consumable,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONSUMABLE_CONFIG.permission,
      showInMenu: CONSUMABLE_CONFIG.showInMenu,
      menuCategory: CONSUMABLE_CONFIG.menuCategory,
      menuSubcategory: CONSUMABLE_CONFIG.menuSubcategory,
      menuTitle: CONSUMABLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'truck-logic',
    pathMatch: 'full',
    component: TruckLogic,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRUCKLOGIC_CONFIG.permission,
      showInMenu: TRUCKLOGIC_CONFIG.showInMenu,
      menuCategory: TRUCKLOGIC_CONFIG.menuCategory,
      menuSubcategory: TRUCKLOGIC_CONFIG.menuSubcategory,
      menuTitle: TRUCKLOGIC_CONFIG.localizationKey,
    },
  },
  {
    path: 'vehicle',
    pathMatch: 'full',
    component: Vehicle,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VEHICLE_CONFIG.permission,
      showInMenu: VEHICLE_CONFIG.showInMenu,
      menuCategory: VEHICLE_CONFIG.menuCategory,
      menuSubcategory: VEHICLE_CONFIG.menuSubcategory,
      menuTitle: VEHICLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'light-vehicle',
    pathMatch: 'full',
    component: LightVehicle,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LIGHTVEHICLE_CONFIG.permission,
      showInMenu: LIGHTVEHICLE_CONFIG.showInMenu,
      menuCategory: LIGHTVEHICLE_CONFIG.menuCategory,
      menuSubcategory: LIGHTVEHICLE_CONFIG.menuSubcategory,
      menuTitle: LIGHTVEHICLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'final-product',
    pathMatch: 'full',
    component: FinalProduct,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FINALPRODUCT_CONFIG.permission,
      showInMenu: FINALPRODUCT_CONFIG.showInMenu,
      menuCategory: FINALPRODUCT_CONFIG.menuCategory,
      menuSubcategory: FINALPRODUCT_CONFIG.menuSubcategory,
      menuTitle: FINALPRODUCT_CONFIG.localizationKey,
    },
  },
  {
    path: 'chemical',
    pathMatch: 'full',
    component: Chemical,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CHEMICAL_CONFIG.permission,
      showInMenu: CHEMICAL_CONFIG.showInMenu,
      menuCategory: CHEMICAL_CONFIG.menuCategory,
      menuSubcategory: CHEMICAL_CONFIG.menuSubcategory,
      menuTitle: CHEMICAL_CONFIG.localizationKey,
    },
  },
  {
    path: 'wood-product-detail',
    pathMatch: 'full',
    component: WoodProductDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WOODPRODUCTDETAIL_CONFIG.permission,
      showInMenu: WOODPRODUCTDETAIL_CONFIG.showInMenu,
      menuCategory: WOODPRODUCTDETAIL_CONFIG.menuCategory,
      menuSubcategory: WOODPRODUCTDETAIL_CONFIG.menuSubcategory,
      menuTitle: WOODPRODUCTDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'truck',
    pathMatch: 'full',
    component: Truck,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRUCK_CONFIG.permission,
      showInMenu: TRUCK_CONFIG.showInMenu,
      menuCategory: TRUCK_CONFIG.menuCategory,
      menuSubcategory: TRUCK_CONFIG.menuSubcategory,
      menuTitle: TRUCK_CONFIG.localizationKey,
    },
  },
  {
    path: 'nursery-truck-parameter',
    pathMatch: 'full',
    component: NurseryTruckParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: NURSERYTRUCKPARAMETER_CONFIG.permission,
      showInMenu: NURSERYTRUCKPARAMETER_CONFIG.showInMenu,
      menuCategory: NURSERYTRUCKPARAMETER_CONFIG.menuCategory,
      menuSubcategory: NURSERYTRUCKPARAMETER_CONFIG.menuSubcategory,
      menuTitle: NURSERYTRUCKPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'vehicle-type',
    pathMatch: 'full',
    component: VehicleType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VEHICLETYPE_CONFIG.permission,
      showInMenu: VEHICLETYPE_CONFIG.showInMenu,
      menuCategory: VEHICLETYPE_CONFIG.menuCategory,
      menuSubcategory: VEHICLETYPE_CONFIG.menuSubcategory,
      menuTitle: VEHICLETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'fundamental-process',
    pathMatch: 'full',
    component: FundamentalProcess,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FUNDAMENTALPROCESS_CONFIG.permission,
      showInMenu: FUNDAMENTALPROCESS_CONFIG.showInMenu,
      menuCategory: FUNDAMENTALPROCESS_CONFIG.menuCategory,
      menuSubcategory: FUNDAMENTALPROCESS_CONFIG.menuSubcategory,
      menuTitle: FUNDAMENTALPROCESS_CONFIG.localizationKey,
    },
  },
  {
    path: 'main-process',
    pathMatch: 'full',
    component: MainProcess,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MAINPROCESS_CONFIG.permission,
      showInMenu: MAINPROCESS_CONFIG.showInMenu,
      menuCategory: MAINPROCESS_CONFIG.menuCategory,
      menuSubcategory: MAINPROCESS_CONFIG.menuSubcategory,
      menuTitle: MAINPROCESS_CONFIG.localizationKey,
    },
  },
  {
    path: 'main-truck-historic',
    pathMatch: 'full',
    component: MainTruckHistoric,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MAINTRUCKHISTORIC_CONFIG.permission,
      showInMenu: MAINTRUCKHISTORIC_CONFIG.showInMenu,
      menuCategory: MAINTRUCKHISTORIC_CONFIG.menuCategory,
      menuSubcategory: MAINTRUCKHISTORIC_CONFIG.menuSubcategory,
      menuTitle: MAINTRUCKHISTORIC_CONFIG.localizationKey,
    },
  },
  {
    path: 'external-service',
    pathMatch: 'full',
    component: ExternalService,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EXTERNALSERVICE_CONFIG.permission,
      showInMenu: EXTERNALSERVICE_CONFIG.showInMenu,
      menuCategory: EXTERNALSERVICE_CONFIG.menuCategory,
      menuSubcategory: EXTERNALSERVICE_CONFIG.menuSubcategory,
      menuTitle: EXTERNALSERVICE_CONFIG.localizationKey,
    },
  },
  {
    path: 'header',
    pathMatch: 'full',
    component: Header,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HEADER_CONFIG.permission,
      showInMenu: HEADER_CONFIG.showInMenu,
      menuCategory: HEADER_CONFIG.menuCategory,
      menuSubcategory: HEADER_CONFIG.menuSubcategory,
      menuTitle: HEADER_CONFIG.localizationKey,
    },
  },
  {
    path: 'holiday-date',
    pathMatch: 'full',
    component: HolidayDate,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HOLIDAYDATE_CONFIG.permission,
      showInMenu: HOLIDAYDATE_CONFIG.showInMenu,
      menuCategory: HOLIDAYDATE_CONFIG.menuCategory,
      menuSubcategory: HOLIDAYDATE_CONFIG.menuSubcategory,
      menuTitle: HOLIDAYDATE_CONFIG.localizationKey,
    },
  },
  {
    path: 'remsoft-species-group',
    pathMatch: 'full',
    component: RemsoftSpeciesGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REMSOFTSPECIESGROUP_CONFIG.permission,
      showInMenu: REMSOFTSPECIESGROUP_CONFIG.showInMenu,
      menuCategory: REMSOFTSPECIESGROUP_CONFIG.menuCategory,
      menuSubcategory: REMSOFTSPECIESGROUP_CONFIG.menuSubcategory,
      menuTitle: REMSOFTSPECIESGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'plant-type',
    pathMatch: 'full',
    component: PlantType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANTTYPE_CONFIG.permission,
      showInMenu: PLANTTYPE_CONFIG.showInMenu,
      menuCategory: PLANTTYPE_CONFIG.menuCategory,
      menuSubcategory: PLANTTYPE_CONFIG.menuSubcategory,
      menuTitle: PLANTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'species-group-plant-type',
    pathMatch: 'full',
    component: SpeciesGroupPlantType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIESGROUPPLANTTYPE_CONFIG.permission,
      showInMenu: SPECIESGROUPPLANTTYPE_CONFIG.showInMenu,
      menuCategory: SPECIESGROUPPLANTTYPE_CONFIG.menuCategory,
      menuSubcategory: SPECIESGROUPPLANTTYPE_CONFIG.menuSubcategory,
      menuTitle: SPECIESGROUPPLANTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'species-group-chip-cubic-meter-coefficient',
    pathMatch: 'full',
    component: SpeciesGroupChipCubicMeterCoefficient,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG.permission,
      showInMenu: SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG.showInMenu,
      menuCategory: SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG.menuCategory,
      menuSubcategory: SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG.menuSubcategory,
      menuTitle: SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'species-per-vehicle-category',
    pathMatch: 'full',
    component: SpeciesPerVehicleCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIESPERVEHICLECATEGORY_CONFIG.permission,
      showInMenu: SPECIESPERVEHICLECATEGORY_CONFIG.showInMenu,
      menuCategory: SPECIESPERVEHICLECATEGORY_CONFIG.menuCategory,
      menuSubcategory: SPECIESPERVEHICLECATEGORY_CONFIG.menuSubcategory,
      menuTitle: SPECIESPERVEHICLECATEGORY_CONFIG.localizationKey,
    },
  },
];

export const GENERAL_ROUTES_WITH_PERMISSIONS = GENERAL_ROUTES;
